
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"fp7kq8j9ea","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"14","height":"14"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h14v14H0z"}})]),_c('g',{attrs:{"mask":"url(#fp7kq8j9ea)"}},[_c('path',{attrs:{"d":"M12.25 4.083h-3.5V2.917h3.5v1.166zM2.917 12.25V2.917c0-.321.114-.596.343-.824.228-.229.503-.343.824-.343h4.083c-.194.292-.34.571-.438.839a2.656 2.656 0 00-.145.911c0 .7.22 1.317.663 1.852.443.535 1 .87 1.67 1.006.224.03.418.044.583.044.166 0 .36-.014.584-.044v5.892L7 10.5l-4.083 1.75z","fill":"#757575"}})])])
          )
        }
      }
    